import React, { Component } from "react";
import AddStudent from "../AddStudent/AddStudent";

class EditStudent extends Component {
  render() {
    return (
      <AddStudent editStatus={true} studentId={this.props.match.params.id} />
    );
  }
}

export default EditStudent;
